<template>
<form class="ui large form" @submit.prevent="send" :class="{'warning': form.hasErrors()}">
  <app-message :msg="form.appMessage"></app-message>
  <div class="fields">
    <div class="six wide field">
      <div class="ui left icon input">
        <i class="lock icon"></i>
        <input v-model="form.model.new_password" type="password" :placeholder="'新しいパスワード'">
      </div>
      <validation-message :form="form" :field="'new_password'"></validation-message>
    </div>
  </div>
  <div class="fields">
    <div class="six wide field">
      <div class="ui left icon input">
        <i class="lock icon"></i>
        <input v-model="form.model.password_confirm" type="password" :placeholder="'確認用'">
      </div>
      <validation-message :form="form" :field="'password_confirm'"></validation-message>
    </div>
  </div>
  <button type="submit" class="ui submit button orange" :class="{'loading': form.waiting}">保存する</button>
</form>
</template>

<script>
export default {
    data: function() {
        return {
            form: this.createForm()
        };
    },
    methods: {
        send: function() {
            this.form.put('/api/users/password', function() {
                alert('パスワードが変更されました');
                window.location.reload();
            });
        }
    }
};
</script>
